import { type Cadence, cadenceFromRange } from './metricLens';
import type { RangePreset } from './useDateRange';

// Derives the chart cadence from the ACTUAL spacing of the timeseries buckets
// the API returned, rather than trusting the preset alone. The API picks
// granularity by span (≤~1d apart → daily, ≤~7d → weekly, else monthly); reading
// it back from the data keeps the x-axis labels honest even if the API's
// bucketing and the preset ever drift. Falls back to the preset-derived cadence
// when there are fewer than two buckets to measure.

const DAY_MS = 24 * 60 * 60 * 1000;
// A little slack above the nominal spacing absorbs DST shifts and month-length
// variance without misclassifying the cadence.
const DAILY_MAX_DAYS = 1.5;
const WEEKLY_MAX_DAYS = 10;

/** Bucket spacing inferred from the gap between the first two period starts. */
export function cadenceFromBuckets(periodStarts: readonly string[], preset: RangePreset): Cadence {
  if (periodStarts.length < 2) return cadenceFromRange(preset);

  const first = Date.parse(periodStarts[0]);
  const second = Date.parse(periodStarts[1]);
  if (Number.isNaN(first) || Number.isNaN(second)) return cadenceFromRange(preset);

  const gapDays = Math.abs(second - first) / DAY_MS;
  if (gapDays <= DAILY_MAX_DAYS) return 'daily';
  if (gapDays <= WEEKLY_MAX_DAYS) return 'weekly';
  return 'monthly';
}
